import React, { Component } from "react";
import { Link } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import { Container, Nav, Offcanvas } from "react-bootstrap";
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { EXCLUDE_LIST } from "../../../constants/Constants";
import { getCookie } from "../../Utils/Utils";
import Navigation from "../Navigation/Navigation";
import { connect } from "react-redux";

require("./Header.scss");

class Header extends Component {
  componentDidMount() {
    let email = getCookie("emailId");
    let qrCodeValue = getCookie("qrCode");
    let userId = getCookie("userId");
    this.setState({qrCode: qrCodeValue});
    this.setState({"userId":userId});
    if(EXCLUDE_LIST.includes(email)) {
      this.setState({ includeInExcludeList: true });
    }
    
  }

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      userId: "",
      qrCode: "",
      includeInExcludeList: false
    };
  }

  handleShow() {
    this.setState({ show: this.state.show ? false : true });
  }
  render() {
    return (
       <Navbar sticky="top" variant="dark">
        <Container className="header-container">
          <Navbar.Brand className="navigation-brand" as={Link} to="/home">
            <img className="navigation-logo" src="/NBCF-LOGO.png" alt="" />
            <div className="navigation-logo-name">
              New Beginnings Christian Fellowship
            </div>
          </Navbar.Brand>
          {/*<Nav className="navigation-desktop">
            <Navigation/>
            <Nav.Link
              as={Link}
              className="navigation-link-desktop-icon"
              to="/cart"
            >
              <ShoppingCartIcon className="navigation-icon" />
              <div className="navigation-title">Cart</div>
            </Nav.Link>
            <Nav.Link
              as={Link}
              className="navigation-link-desktop-icon"
              to="/profile"
            >
              <AccountCircleIcon className="navigation-icon" />
              <div className="navigation-title">Account</div>
            </Nav.Link>
          </Nav>
          <Nav.Link
            as={Link}
            className="navigation-link-mobile-icon"
            to="/cart"
          >
            <ShoppingCartIcon className="navigation-icon" />
          </Nav.Link>
          <Nav.Link as={Link} className="navigation-link-mobile-icon" to="#">
            <MenuIcon
              className="navigation-icon"
              onClick={() => {
                this.handleShow();
              }}
            />
          </Nav.Link>
          <Offcanvas
            show={this.state.show}
            onHide={() => {
              this.handleShow();
            }}
            placement="end"
            className="navigation-mobile-canvas"
          >
            <Offcanvas.Header closeButton>
              <Navbar.Brand className="navigation-brand" as={Link} to="/home">
                <img className="navigation-logo" src="/NBCF-LOGO.png" alt="" />
                <div className="navigation-logo-name">
                  New Beginnings Christian Fellowship
                </div>
              </Navbar.Brand>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="navigation-mobile">
                <Navbar.Text>User Id: {this.state.userId}</Navbar.Text>
                <img
                  src={this.state.qrCode}
                  alt="user-qr"
                  className="profile-QR"
                />
                <Navigation/>
                <Nav.Link as={Link} className="navigation-link" to="/profile">
                  <div className="navigation-title">Account</div>
                </Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Offcanvas> */}
        </Container> 
      </Navbar> 
    );
  }
}

const mapStateToProps = state => {
  return {
    qrCode: state? state.qrCode: "",
    userId: state? state.userId: ""
  };
};

export default connect(mapStateToProps, null, null, {
  pure: false
})(Header);
